import { surgeonConstants } from "../constants";
import { surgeonService } from "../services";

export const surgeonActions = {
    getList,
    add,
    getById,
    update,
    delete: _delete,
    getSurgeonsList
};

function getList(search) {
    return dispatch => {
        dispatch(request());

        surgeonService.getList(search)
            .then(
                list => dispatch(success(list)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: surgeonConstants.GETALLSURGEONS_REQUEST }; }
    function success(lists) { return { type: surgeonConstants.GETALLSURGEONS_SUCCESS, lists }; }
    function failure(error) { return { type: surgeonConstants.GETALLSURGEONS_FAILURE, error }; }
}

function add(info) {
    return dispatch => {
        dispatch(request());

        surgeonService.add(info)
            .then(
                info => dispatch(success(info)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: surgeonConstants.SURGEONADD_REQUEST }; }
    function success(info) { return { type: surgeonConstants.SURGEONADD_SUCCESS, info }; }
    function failure(error) { return { type: surgeonConstants.SURGEONADD_FAILURE, error }; }
}

function update(info) {
    return dispatch => {
        dispatch(request());

        surgeonService.update(info)
            .then(
                info => dispatch(success(info)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: surgeonConstants.SURGEONUPDATE_REQUEST }; }
    function success(info) { return { type: surgeonConstants.SURGEONUPDATE_SUCCESS, info }; }
    function failure(error) { return { type: surgeonConstants.SURGEONUPDATE_FAILURE, error }; }
}

function getById(id) {
    return dispatch => {
        dispatch(request());

        surgeonService.getById(id)
            .then(
                list => dispatch(success(list)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: surgeonConstants.SURGEONEDIT_REQUEST }; }
    function success(list) { return { type: surgeonConstants.SURGEONEDIT_SUCCESS, list }; }
    function failure(error) { return { type: surgeonConstants.SURGEONEDIT_FAILURE, error }; }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    return dispatch => {
        dispatch(request(id));

        surgeonService.delete(id)
            .then(
                kit => { 
                    console.log(kit);
                    dispatch(success(id));
                },
                error => {
                    dispatch(failure(id, error));
                }
            );
    };

    function request(id) { return { type: surgeonConstants.DELETE_REQUEST, id }; }
    function success(id) { return { type: surgeonConstants.DELETE_SUCCESS, id }; }
    function failure(id, error) { return { type: surgeonConstants.DELETE_FAILURE, id, error }; }
}

function getSurgeonsList(search) {
    return dispatch => {
        dispatch(request());

        surgeonService.getSurgeonsList(search)
            .then(
                list => dispatch(success(list)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: surgeonConstants.GETALLSURGEONSLIST_REQUEST }; }
    function success(lists) { return { type: surgeonConstants.GETALLSURGEONSLIST_SUCCESS, lists }; }
    function failure(error) { return { type: surgeonConstants.GETALLSURGEONSLIST_FAILURE, error }; }
}